export default "__VITE_ASSET__BxB8bgyz__"